import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/asset-management-dashboard': { label: 'Asset Dashboard', parent: null },
    '/asset-detail-management': { label: 'Asset Details', parent: '/asset-management-dashboard' },
    '/quarterly-audit-workflow': { label: 'Audit Workflow', parent: null },
    '/warranty-management-center': { label: 'Warranty Center', parent: null },
    '/asset-analytics-dashboard': { label: 'Analytics Dashboard', parent: null },
    '/user-management-console': { label: 'User Management', parent: null },
    '/system-configuration-panel': { label: 'System Configuration', parent: null }
  };

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const currentPath = location?.pathname;
    const currentRoute = routeMap?.[currentPath];
    
    if (!currentRoute) {
      return [{ label: 'Dashboard', path: '/asset-management-dashboard', isActive: false }];
    }

    const breadcrumbs = [];
    
    // Add home/root
    breadcrumbs?.push({
      label: 'Home',
      path: '/asset-management-dashboard',
      isActive: false,
      icon: 'Home'
    });

    // Add parent if exists
    if (currentRoute?.parent && currentRoute?.parent !== '/asset-management-dashboard') {
      const parentRoute = routeMap?.[currentRoute?.parent];
      if (parentRoute) {
        breadcrumbs?.push({
          label: parentRoute?.label,
          path: currentRoute?.parent,
          isActive: false
        });
      }
    }

    // Add current page
    if (currentPath !== '/asset-management-dashboard') {
      breadcrumbs?.push({
        label: currentRoute?.label,
        path: currentPath,
        isActive: true
      });
    } else {
      breadcrumbs[0].isActive = true;
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigation = (path) => {
    if (path && path !== location?.pathname) {
      navigate(path);
    }
  };

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((item, index) => (
          <li key={item?.path || index} className="flex items-center space-x-2">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={14} 
                className="text-muted-foreground" 
              />
            )}
            
            <div className="flex items-center space-x-1">
              {item?.icon && (
                <Icon 
                  name={item?.icon} 
                  size={14} 
                  className={item?.isActive ? 'text-foreground' : 'text-muted-foreground'} 
                />
              )}
              
              {item?.isActive ? (
                <span className="font-medium text-foreground" aria-current="page">
                  {item?.label}
                </span>
              ) : (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleNavigation(item?.path)}
                  className="h-auto p-0 font-normal text-muted-foreground hover:text-foreground transition-smooth"
                >
                  {item?.label}
                </Button>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;